import React from 'react';
import { Form } from 'antd';
import DispexInput, {
  typeInput,
} from '../../../.././../../components/DispexInput';
import { docTypes } from '../../../../constants/documents.constants';
import DatePickerCustom, {
  enumTypePicker,
} from '../../../../components/DatePickerCustom';
import { useDispatch, useSelector } from 'react-redux';
import {
  applySourceDateDocument,
  applySourceDocumentNumber,
  applyDeadlineDate,
} from '../../../../store/actions/documentFilterNew.actions';

const DocumentParameters = () => {
  const { sourceDate, sourceNumber, typeId, deadlineDate } = useSelector(
    (state) => state.documentFilterNewStore
  );

  const showResponseDate =
    typeId === docTypes.incoming || typeId === docTypes.citizenAppeal;
  const showInDoc =
    typeId === docTypes.incoming || typeId === docTypes.outgoing;

  const dispatch = useDispatch();

  const handleChangeBindDocument = (value) => {
    dispatch(applySourceDateDocument(value));
  };

  const handleChangeBindDocumentNumber = (value) => {
    dispatch(applySourceDocumentNumber(value));
  };

  const handleChangeDeadlineDate = (value) => {
    dispatch(applyDeadlineDate(value));
  };

  return (
    <div>
      {showResponseDate && (
        <Form.Item
          style={{ margin: 0 }}
          label="Срок ответа"
        >
          <DatePickerCustom
            typePicker={enumTypePicker.RANGE}
            size="large"
            placeholder={['ДД.ММ.ГГГГ', 'ДД.ММ.ГГГГ']}
            style={{ width: '100%' }}
            value={deadlineDate}
            onChange={(value) => handleChangeDeadlineDate(value)}
          />
        </Form.Item>
      )}
      {showInDoc && (
        <>
          <Form.Item
            style={{ margin: 0 }}
            label={
              docTypes.outgoing === typeId
                ? 'Дата входящего документа'
                : 'Дата исходящего документа'
            }
          >
            <DatePickerCustom
              placeholder={['ДД.ММ.ГГГГ', 'ДД.ММ.ГГГГ']}
              typePicker={enumTypePicker.RANGE}
              size="large"
              style={{ width: '100%' }}
              value={sourceDate}
              onChange={(value) => handleChangeBindDocument(value)}
            />
          </Form.Item>
          <Form.Item
            style={{ margin: 0 }}
            label={
              docTypes.outgoing === typeId
                ? 'Номер входящего документа'
                : 'Номер исходящего документа'
            }
          >
            <DispexInput
              placeholder="Введите номер документа"
              typeInput={typeInput.input}
              value={sourceNumber}
              onChange={(value) =>
                handleChangeBindDocumentNumber(value.target.value)
              }
              style={{ height: '40px' }}
            />
          </Form.Item>
        </>
      )}
    </div>
  );
};

export default DocumentParameters;
